import React from "react";
import { Box, InputAdornment, TextField } from "convertupleads-theme";
import PreviewAndEditor from "../../../../common/PreviewAndEditor";

const TextFieldWithStartAdornText = () => {
  return (
    <Box sx={{ width: "80%", marginInline: " auto", p: 3 }}>
      <PreviewAndEditor
        title={"textfield with Start text adornment"}
        language={"js"}
        value={
          "         <TextField\n" +
          '          label="Outlined"\n' +
          '          placeholder={"search"}\n' +
          "          InputProps={{\n" +
          "            startAdornment: (\n" +
          '              <InputAdornment position="start">\n' +
          "                https://\n" +
          "              </InputAdornment>\n" +
          "            ),\n" +
          "          }}\n" +
          "        />\n" +
          "        <TextField\n" +
          '          label="Filled"\n' +
          '          variant="filled"\n' +
          '          placeholder={"search"}\n' +
          "          InputProps={{\n" +
          "            startAdornment: (\n" +
          '              <InputAdornment position="start">\n' +
          "                https://\n" +
          "              </InputAdornment>\n" +
          "            ),\n" +
          "          }}\n" +
          "        />\n" +
          "        <TextField\n" +
          '          label="Standard"\n' +
          '          variant="standard"\n' +
          '          placeholder={"search"}\n' +
          "          InputProps={{\n" +
          "            startAdornment: (\n" +
          '              <InputAdornment position="start">\n' +
          "                https://\n" +
          "              </InputAdornment>\n" +
          "            ),\n" +
          "          }}\n" +
          "        />"
        }
      >
        <TextField
          label="Outlined"
          placeholder={"search"}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                https://
              </InputAdornment>
            ),
          }}
        />
        <TextField
          label="Filled"
          variant="filled"
          placeholder={"search"}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                https://
              </InputAdornment>
            ),
          }}
        />
        <TextField
          label="Standard"
          variant="standard"
          placeholder={"search"}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                https://
              </InputAdornment>
            ),
          }}
        />
      </PreviewAndEditor>
    </Box>
  );
};

export default TextFieldWithStartAdornText;
